import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: "https://hworldbackend.fly.dev",
});

// Add a request interceptor to include the API key
instance.interceptors.request.use(
  (config) => {
    // config.headers["x-api-key"] = process.env.REACT_APP_API_KEY;
    config.headers["x-api-key"] = "xY9f$2Kp#mQ7zL3@jN6*wR4";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
